import React from 'react';
import { motion } from 'framer-motion';
import { SectionDivider } from './SectionDivider';
export function Testimonials() {
  const testimonials = [{
    quote: 'En la primera semana ya tenía mi vela con etiqueta y precio. El domingo siguiente vendí 2.',
    author: 'María G.',
    location: 'Texas'
  }, {
    quote: 'El Blend Book solo ya vale más que los $17. Mis clientes siempre preguntan si estudié aromaterapia.',
    author: 'Lucía M.',
    location: 'California'
  }, {
    quote: 'Antes cambiaba todo al mismo tiempo y nunca sabía qué funcionó. Con el sistema de una variable por prueba, en 2 semanas encontré mi fórmula perfecta.',
    author: 'Carmen R.',
    location: 'Florida'
  }];
  return <section className="bg-brand-alt py-14" data-id="element-131">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="text-center mb-10" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text" data-id="element-134">
            LO QUE DICEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-135">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-brand-bg p-8 rounded-2xl border border-brand-line/20 flex flex-col justify-between" data-id="element-136">
              <div className="mb-6" data-id="element-137">
                <div className="flex gap-1 mb-4 text-brand-ctaStart" data-id="element-138">
                  {[...Array(5)].map((_, j) => <svg key={j} className="w-5 h-5 fill-current" viewBox="0 0 20 20" data-id="element-139">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-140" />
                    </svg>)}
                </div>
                <p className="text-lg text-brand-text font-heading italic leading-relaxed" data-id="element-141">
                  "{testimonial.quote}"
                </p>
              </div>
              <div data-id="element-142">
                <p className="font-bold text-brand-text" data-id="element-143">
                  {testimonial.author}
                </p>
                <p className="text-sm text-brand-subtext" data-id="element-144">
                  {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
      <SectionDivider data-id="element-145" />
    </section>;
}